import { Component, Input, inject, ChangeDetectorRef, signal } from '@angular/core';
import { composeIBAN } from 'ibantools'
import * as QRCode from 'qrcode';
import { DeviceService } from 'src/services/device.service';
import { Filesystem, Directory } from '@capacitor/filesystem'
import { Share } from '@capacitor/share'

@Component({
  selector: 'liberro-qr-payment',
  templateUrl: './qr-payment.component.html',
  styleUrls: ['./qr-payment.component.less'],
  standalone: false
})
export class QrPaymentComponent {
  @Input() public variableSymbol!: string;
  @Input() public specificSymbol?: string;
  @Input() public accountNumber!: string;
  @Input() public amount?: number;
  @Input() public bankCode!: string;
  @Input() public currency!: 'CZK' | 'EUR';

  private deviceService = inject(DeviceService);
  private cdr = inject(ChangeDetectorRef);
  public qrImageData = signal<string | null>(null);

  public getQrString(): void {
    const accountNumberTokens = this.accountNumber.split('-')

    let paddedPrefix
    let paddedAccountNumber

    if (accountNumberTokens.length === 1) {
      if (accountNumberTokens[0].length > 10) {
        console.warn('BWM QR: Passed account number is longer than 10 characters!')
      }

      paddedPrefix = ''.trim().padStart(6, '0')
      paddedAccountNumber = accountNumberTokens[0].slice(0, 10).trim().padStart(10, '0')
    } else {
      if (accountNumberTokens[1].length > 10) {
        console.warn('BWM QR: Passed account number is longer than 10 characters!')
      }

      paddedPrefix = accountNumberTokens[0].trim().padStart(6, '0')
      paddedAccountNumber = accountNumberTokens[1].slice(0, 10).trim().padStart(10, '0')
    }

    const bban = `${this.bankCode}${paddedPrefix}${paddedAccountNumber}`
    const iban = composeIBAN({countryCode: 'CZ', bban: bban})

    let qrData = `SPD*1.0*ACC:${iban}${ this.amount ? '*AM:' + Math.round(this.amount) : ''}*CC:${this.currency}*X-VS:${this.variableSymbol}*`;

    if(this.specificSymbol) {
      qrData += `X-SS:${this.specificSymbol}*`;
    }

    QRCode.toDataURL(qrData)
      .then(url => {
        this.qrImageData.set(url);
        this.cdr.detectChanges();
      })
      .catch(err => {
        console.error(err)
      })
  }

  public async downloadImg(): Promise<void> {
    if(this.deviceService.isNativePlatform) {
      const base64Data = this.qrImageData()?.split(',')[1] ?? ''

      await Filesystem.writeFile({
        path: 'BWM_deposit_QR.png',
        data: base64Data,
        directory: Directory.Cache
      })

      const uri = await Filesystem.getUri({
        path: 'BWM_deposit_QR.png',
        directory: Directory.Cache
      })

      await Share.share({
        title: 'BWM deposit QR',
        url: uri.uri,
        dialogTitle: 'BWM deposit QR'
      })
    } else {
      const link = document.createElement('a');
      link.href = this.qrImageData() ?? '';
      link.download = 'BWM deposit QR';

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    }
  }
}
